window.Search = new function()
{
    this.init = function() {
        jQuery('.open-search').click(function(event) {
            event.preventDefault();
            jQuery('.search-modal').removeClass('hide');
            jQuery('html').addClass('search-open');

            //Focus on search input and seek to end
            jQuery('.search-modal input[name="s"]').focus();
            var search_val = jQuery('.search-modal input[name="s"]').val();
            jQuery('.search-modal input[name="s"]').val('');
            jQuery('.search-modal input[name="s"]').val(search_val);
        });

        jQuery('.close-search').click(function(event) {
            event.preventDefault();
            jQuery('.search-modal').addClass('hide');
            jQuery('html').removeClass('search-open');
        });

        $(document).on('keydown', function(event) {
            if (event.key == "Escape") {
                jQuery('.search-modal').addClass('hide');
                jQuery('.channel-collection-search-modal').addClass('hide');
                jQuery('html').removeClass('search-open');
                jQuery('html').removeClass('channel-collection-search-open');
            }
        });
    };
}

jQuery(document).ready(function($) {
    Search.init();
});
